import React, { Component } from 'react';
import '../../styles/areafield.scss';
import { Column } from '../index';
import { getPercentage, sortPlayersAsc, HOME, AWAY } from '../../index';
import { Player } from 'src/mundial/requests/interfaces';

interface IAreaFieldProps {
    type: string;
    formation: number[];
    players: Player[];
}
export default class AreaField extends Component<IAreaFieldProps> {
    type: string;
    formation: string;
    state: {
        formation: string[];
        players?: Player[];
        width: number;
        valuesSlicePlayer?: {
            left: number[];
            right: number[];
        };
    };
    constructor(props: IAreaFieldProps) {
        super(props);
        this.type = this.props.type || '';
        this.state = {
            formation: [],
            width: 0,
            valuesSlicePlayer: {
                left: [],
                right: [],
            },
        };
        this.setSizeWidth = this.setSizeWidth.bind(this);
        this.getValuesSlicePlayer = this.getValuesSlicePlayer.bind(this);
        this.getClassNameMovePlayer = this.getClassNameMovePlayer.bind(this);
    }

    setSizeWidth(columns: number[]) {
        const length = columns.length;
        const calc = getPercentage(length);
        this.setState({ width: calc });
    }

    getValuesSlicePlayer(init: number, valueArray: number[], formation: number[]) {
        formation.map((value) => {
            const valueAux = init + value;
            valueArray.push(valueAux);
            init = valueAux;
        });
    }

    getClassNameMovePlayer(index: number, rows: number, formation: string[]): string {
        const sizeFormation = formation.length;
        const odd = index !== 0 && index !== sizeFormation - 1 && index % 2 !== 0;
        const size = rows === 1 || rows === 3 || rows === 4;
        if (odd && size) {
            return 'move-player';
        } else if (index === 0) {
            return 'move-goalkeeper';
        } else {
            return '';
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IAreaFieldProps>, nextContext: any): void {
        const formation = nextProps.formation;
        const validateFormation = typeof formation === 'object';
        const validatePlayers = typeof nextProps.players === 'object';
        const players = validatePlayers
            ? nextProps.players?.filter(({ lineupStatus }) => {
                  return lineupStatus === 'STARTER';
              })
            : [];
        this.setState({ players, formation: validateFormation ? formation : [] });
        this.setSizeWidth(formation);

        let initLeft = 0;
        const left: number[] = [initLeft];

        this.getValuesSlicePlayer(initLeft, left, formation);

        let initRight = 0;
        const right: number[] = [];

        this.getValuesSlicePlayer(initRight, right, formation);
        left.pop();

        this.setState({ valuesSlicePlayer: { left, right } });
    }

    render() {
        const { width, players = [], formation, valuesSlicePlayer } = this.state;
        const sortPlayers = players.sort(sortPlayersAsc);

        return (
            <div id="areaField" className={`${this.type}`}>
                {formation.map((numberRows, index) => (
                    <Column
                        key={index}
                        type={this.type}
                        width={`${width - 0.59}%`}
                        rows={numberRows}
                        players={sortPlayers.slice(
                            valuesSlicePlayer?.left[index],
                            valuesSlicePlayer?.right[index]
                        )}
                        classNameMovePlayer={this.getClassNameMovePlayer(
                            index,
                            parseInt(numberRows),
                            formation
                        )}
                    />
                ))}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/Alignment/AreaField/AreaField.tsx